export default __webpack_public_path__ + "static/media/cdk.1636a2cb.svg";